
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 5","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.556 3.222c.49 0 .889-.364.889-.814 0-.45-.398-.815-.89-.815-.49 0-.888.365-.888.815 0 .45.398.814.889.814zM14.778 3.222c.49 0 .889-.364.889-.814 0-.45-.398-.815-.89-.815-.49 0-.888.365-.888.815 0 .45.398.814.889.814zM2.333 3.223c.491 0 .89-.365.89-.815 0-.45-.399-.815-.89-.815-.49 0-.889.365-.889.815 0 .45.398.815.89.815z","stroke":"#DADADA","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    